<script setup lang="ts">
import { computed, ref } from 'vue'

import ExportStayListButton from '@/stay-list/stay-list-table/actions/ExportStayListButton.vue'
import ReadingListButton from '@/stay-list/stay-list-table/actions/ReadingListButton.vue'
import StayListActions from '@/stay-list/stay-list-table/actions/StayListActions.vue'
import { ListMcoStay } from '@/stay-list/stay-list-table/mco/types'
import { useStore } from '@/store'
import { PmsiTypeEnum } from '@/store/modules/settings/types'

const store = useStore()

const exportError = ref(null)

const mode = computed(() => store.state.stayList.stayListParams.mode)
const stayList = computed(() => store.state.stayList.stayList.items.map((stay: ListMcoStay) => stay.id))
const exportRequest = computed(() => store.getters.getStayListExportRequest)
const params = computed(() => ({
  showSeen: store.state.stayList.stayListParams.showSeen,
  pageSize: store.state.stayList.stayListParams.pageSize
}))

const emit = defineEmits<{
  (e: 'set-stay-list-parameter', type: string, value: number | boolean)
}>()
</script>

<template>
  <stay-list-actions
    :params="params"
    :error-message="exportError"
    @set-stay-list-parameter="(name, value) => $emit('set-stay-list-parameter', name, value)"
  >
    <export-stay-list-button
      :mode="mode"
      :request="exportRequest"
      :pmsi-type="PmsiTypeEnum.MCO"
      @error="message => exportError = message"
    />
    <reading-list-button
      :mode="mode"
      :pmsi-type="PmsiTypeEnum.MCO"
      :stay-list="stayList"
    />
  </stay-list-actions>
</template>
